// ── Interface suggestions ─────────────────────────────────────────────────────

import {
    SUGGESTIONS_PAS,
    SUGGESTIONS_MAX,
    dernièresSuggestions,
    setDernièresSuggestions
} from './état.js';

/**
 * Met à jour les suggestions affichées à l'écran.
 *
 * @param {Array}  result      tableau brut retourné par l'API
 * @param {string} searchText  mot saisi par l'utilisateur (exclu des suggestions)
 * @param {number} [nbVisible] nombre de suggestions à afficher (défaut : SUGGESTIONS_PAS)
 */
export function updateSuggestionResultsHTML(result, searchText, nbVisible) {
    setDernièresSuggestions(result);
    nbVisible = nbVisible || SUGGESTIONS_PAS;

    const suggestionsÉlément       = document.getElementById("dsr-suggestions");
    const suggestionsListeÉlémentOld = document.getElementById("dsr-suggestions-liste");

    const suggestionsListeÉlémentNew = document.createElement("ul");
    suggestionsListeÉlémentNew.id        = "dsr-suggestions-liste";
    suggestionsListeÉlémentNew.className = "dsr-suggestions-liste";

    // Exclure le mot tapé lui-même, puis paginer
    const candidats = result.filter(function(s) { return s !== searchText; });
    const visibles  = candidats.slice(0, nbVisible);

    visibles.forEach(function(mot, i) {
        const suggestion = document.createElement("li");
        suggestion.className = "dsr-suggestions-liste-élément";
        // rechercher() est une fonction globale de usito.js (pont temporaire)
        suggestion.innerHTML = "<a href=\"\" onclick=\"return rechercher('" + mot + "',true)\" tabindex=\"10" + i + "\">" + mot + "</a>";
        suggestionsListeÉlémentNew.appendChild(suggestion);
    });

    // Lien "(plus)" si des suggestions restent et que le plafond n'est pas atteint
    if (candidats.length > nbVisible && nbVisible < SUGGESTIONS_MAX) {
        const nbSuivant  = Math.min(nbVisible + SUGGESTIONS_PAS, SUGGESTIONS_MAX);
        const nbRestants = Math.min(candidats.length - nbVisible, SUGGESTIONS_PAS);

        // Marquer le dernier élément visible avant d'ajouter "(plus)"
        const dernierÉlément = suggestionsListeÉlémentNew.lastChild;
        if (dernierÉlément) {
            dernierÉlément.classList.add("dsr-suggestions-liste-élément--dernier");
        }

        const plusLien = document.createElement("a");
        plusLien.href  = "";
        plusLien.textContent = "plus";
        plusLien.title = "Afficher " + nbRestants + " suggestion"
            + (nbRestants > 1 ? "s" : "")
            + " supplémentaire" + (nbRestants > 1 ? "s" : "");
        plusLien.addEventListener("click", function(e) {
            e.preventDefault();
            // Stopper la propagation : sinon le replaceChild détache le nœud du DOM avant
            // que le listener window ne vérifie contains(), ce qui ferme la zone de recherche.
            e.stopPropagation();
            afficherPlusDeSuggestions(searchText, nbSuivant);
        });

        const plusÉlément = document.createElement("li");
        plusÉlément.className = "dsr-suggestions-liste-plus";
        plusÉlément.appendChild(document.createTextNode("("));
        plusÉlément.appendChild(plusLien);
        plusÉlément.appendChild(document.createTextNode(")"));
        suggestionsListeÉlémentNew.appendChild(plusÉlément);
    }

    if (visibles.length === 0) {
        document.getElementById("dsr-suggestions-label").innerHTML = "Aucune suggestion.";
        // Pont temporaire : envoyerÉvénementGTM() vit encore dans usito.js
        if (typeof window.envoyerÉvénementGTM === 'function') {
            window.envoyerÉvénementGTM('suggestions', 'suggestion_infructueuse', searchText);
        }
    } else {
        document.getElementById("dsr-suggestions-label").innerHTML = "Suggestions&nbsp;:";
        suggestionsÉlément.style.display = "block";
    }

    suggestionsÉlément.replaceChild(suggestionsListeÉlémentNew, suggestionsListeÉlémentOld);
}

/**
 * Affiche le prochain groupe de suggestions sans rappeler l'API.
 * (Les live bindings ES modules garantissent que dernièresSuggestions est à jour.)
 *
 * @param {string} searchText  mot original saisi par l'utilisateur
 * @param {number} nbVisible   nouveau nombre de suggestions à afficher
 */
export function afficherPlusDeSuggestions(searchText, nbVisible) {
    updateSuggestionResultsHTML(dernièresSuggestions, searchText, nbVisible);
}
